"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowSize = void 0;
var react_1 = require("react");
function getSize(w) {
    return {
        innerHeight: w.innerHeight,
        innerWidth: w.innerWidth,
        outerHeight: w.outerHeight,
        outerWidth: w.outerWidth,
    };
}
/**
 * Hook that returns current window dimensions.
 *
 * Note: it might return null on first render,
 * when `window` object is not defined (for server side rendering, for example).
 */
function useWindowSize() {
    var _a = react_1.useState(function () {
        return typeof window !== 'undefined' ? getSize(window) : null;
    }), windowSize = _a[0], setWindowSize = _a[1];
    react_1.useEffect(function () {
        setWindowSize(getSize(window));
        function handleResize() {
            setWindowSize(getSize(window));
        }
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return windowSize;
}
exports.useWindowSize = useWindowSize;
//# sourceMappingURL=useWindowSize.js.map